export function normalizeDialCode(raw?: string | null): string {
  if (!raw) return '';
  const digits = String(raw).replace(/\D/g, '');
  return digits ? `+${digits}` : '';
}

export function localPhoneDigits(raw?: string | null): string {
  return String(raw || '').replace(/\D/g, '');
}

export function composeE164(dialCode: string, localNumber: string): string {
  const dial = normalizeDialCode(dialCode);
  let local = localPhoneDigits(localNumber);
  if (!local) return '';
  if (!dial) return local;
  const dialDigits = dial.replace(/\D/g, '');
  if (dialDigits.length >= 2) {
    const doubled = dialDigits + dialDigits;
    if (local.startsWith(doubled) && local.length - doubled.length >= 4) {
      local = local.slice(dialDigits.length);
    }
  }
  if (local.startsWith(dialDigits) && local.length > dialDigits.length) {
    local = local.slice(dialDigits.length);
  }
  return `${dial}${local}`;
}

export function splitPhoneByDialCodes(
  fullPhone: string,
  dialCodes: string[],
): { dialCode: string; localNumber: string } {
  const raw = String(fullPhone || '').trim();
  if (!raw) return { dialCode: '', localNumber: '' };

  let allDigits = raw.replace(/\D/g, '');
  if (allDigits.startsWith('91') && allDigits.length === 13 && allDigits[2] === '1') {
    allDigits = allDigits.slice(2);
  }

  const fallback = ['+1242', '+1264', '+1268', '+1473', '+1876', '+1939', '+1809', '+1829', '+1849',
    '+971', '+966', '+974', '+973', '+968', '+965', '+91', '+90', '+86', '+84', '+82', '+81',
    '+66', '+65', '+64', '+63', '+62', '+61', '+60', '+49', '+44', '+43', '+41', '+39', '+34',
    '+33', '+32', '+31', '+27', '+20', '+7', '+1'];
  const sorted = [...new Set([...dialCodes, ...fallback].map(normalizeDialCode).filter(Boolean))]
    .sort((a, b) => b.length - a.length);

  for (const dial of sorted) {
    const dialDigits = dial.replace(/\D/g, '');
    if (!dialDigits) continue;
    if (allDigits.startsWith(dialDigits) && allDigits.length - dialDigits.length >= 4) {
      return { dialCode: dial, localNumber: allDigits.slice(dialDigits.length) };
    }
  }

  if ((raw.startsWith('+') || allDigits.length >= 8) && allDigits.length >= 8) {
    for (let len = 4; len >= 1; len -= 1) {
      const prefix = allDigits.slice(0, len);
      if (allDigits.length - len >= 4) {
        return { dialCode: `+${prefix}`, localNumber: allDigits.slice(len) };
      }
    }
  }

  return { dialCode: '', localNumber: allDigits };
}
